// @flow

import { log } from '@atlassian/mpac-utils';
import { useEffect } from 'react';

export type AppListingJsdWidgetProps = {
  jsdWidgetKey: string,
  jiraServiceDeskEmbedBaseUrl: string,
};

// This ID is used in the iframe initialized by the JSD script
// This isn't officially documented, and not something we can affect
const JSDIframeId = 'jsd-widget';

/**
 * Snippet to load JSD widget programatically.
 * @see https://community.atlassian.com/t5/Jira-Service-Management/Dynamically-Embedding-Service-Desk-Widget/qaq-p/899686
 */
function loadJiraServiceDeskWidget({ key, baseUrl }) {
  const jsdScript = document.createElement('script');
  jsdScript.type = 'text/javascript';
  jsdScript.dataset.jsdEmbedded = '';
  jsdScript.dataset.key = key;
  jsdScript.dataset.baseUrl = baseUrl;
  jsdScript.src = `${baseUrl}/assets/embed.js`;
  jsdScript.defer = true;

  jsdScript.addEventListener('load', () => {
    const DOMContentLoaded_event = document.createEvent('Event');
    DOMContentLoaded_event.initEvent('DOMContentLoaded', true, true);
    window.document.dispatchEvent(DOMContentLoaded_event);
  });
  document.getElementsByTagName('head')[0].appendChild(jsdScript);
  return jsdScript;
}

function unloadJiraServiceDeskWidget(jsdScript) {
  const jsdWidgetIframe = document.getElementById(JSDIframeId);
  if (!jsdScript || !jsdWidgetIframe) {
    log.error(
      'JSD Widget',
      'Could not locate either the JSD script or the widget iframe, and cleanup resources'
    );
    return;
  }

  jsdScript.remove();
  jsdWidgetIframe.remove();
}

const AppListingJsdWidget = (props: AppListingJsdWidgetProps) => {
  useEffect(() => {
    const jsdScript = loadJiraServiceDeskWidget({
      key: props.jsdWidgetKey,
      baseUrl: props.jiraServiceDeskEmbedBaseUrl,
    });

    return () => unloadJiraServiceDeskWidget(jsdScript);
  }, []);
  return null;
};

export default AppListingJsdWidget;
